import Layout from '~/layouts/default';
import Seo from '~/components/seo';
import Main from '~/components/main';
import Advantages from '~/components/advantages';
import Advantage from '~/components/advantage';
import CommonAdvantages from '~/components/advantages/commonAdvantages';
import CtaClick from '~/components/ctaClick';
import {
  getDocsUrl
} from '~/helpers/url';

export default function Page() {
  return (
    <>
      <Layout>
        <Seo
          title="Self-hosted"
          description="Repman on-premises lets you to manage all PHP dependencies in your organization in a fast and secure way."
          path="/self-hosted"
        />
        <Main className="on-premises">
          <Main.Header primary title="Composer Package Manager behind your firewall">
            Repman on-premises lets you to manage all PHP dependencies in
            your organization in a fast and secure way.
          </Main.Header>
          <Main.Content>
            <CtaClick cta={['install-self-hosted-self-hosted']}>
              <a
                href={getDocsUrl('standalone')}
                className="btn btn-secondary btn-icon _download"
              >
                Install Self-hosted
              </a>
            </CtaClick>
          </Main.Content>
        </Main>
        <Advantages>
          <CommonAdvantages />
          <Advantage>
            <Advantage.Header>
              Reduce<br />transfer
            </Advantage.Header>
            <Advantage.Content>
              Packages from external registries are downloaded only once.
            </Advantage.Content>
          </Advantage>
          <Advantage>
            <Advantage.Header>
              Powerful<br />Insights
            </Advantage.Header>
            <Advantage.Content>
              Control what PHP packages are used in your organization.
            </Advantage.Content>
          </Advantage>
          <Advantage>
            <Advantage.Header>
              Security
            </Advantage.Header>
            <Advantage.Content>
              Protect against removing a package from Packagist.
            </Advantage.Content>
          </Advantage>
          <Advantage>
            <Advantage.Header>
              Organizations
            </Advantage.Header>
            <Advantage.Content>
              Manage your private packages inside your organization.
            </Advantage.Content>
          </Advantage>
        </Advantages>
      </Layout>
    </>
  );
}
